import React, { Component } from 'react'
import forOwn from 'mout/object/forOwn'
import { Card, CardBody, Button, Row, Col } from 'reactstrap'
import { Link } from 'react-router-dom'
import { SkillGroup } from './'
import { AssessDashCircle, } from '../'
import shortid from 'shortid'
import queryString from 'query-string'
import {map} from 'lodash'

class SkillGroups extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeParentReport: '',
    }

    this.setActiveParent = this.setActiveParent.bind(this)
    this.getNodeFilter = this.getNodeFilter.bind(this)
  }

  setActiveParent(id) {
    this.setState((prevState, props) => {
      if (prevState.activeParentReport == id) {
        return { activeParentReport: '' }
      } else {
        return { activeParentReport: id }
      }
    })
  }

  getNodeFilter() {
    const query = this.props.query
    let nodeFilter = ''
    if (query && query.nd) {
      nodeFilter = query.nd
    }
    return nodeFilter
  }

  render() {
    const { report, color, name, query, navTo, routeParams, assessmentId, isStudent , reportCompare  } = this.props
    let { scaleScore , scaleScoreCompare } = this.props
    const { userAssessmentId, subTestSetId } = routeParams
    const nodeFilter = this.getNodeFilter()
    
    const overviewLink = `/assessment/dashboard/${assessmentId}${dashQuery}`
    const skillReportLink = `/assessment/reports/${userAssessmentId}/${subTestSetId}?${reportQueryString}`

    let skillGroups = [] 
    
    if(reportCompare !== null && reportCompare && reportCompare.report){
      map(reportCompare.report,(node,i)=>{

          map(node,(rD, ir)=>{
            report.report[i][ir].percent1 =  rD.percent
          })
         

      })
    }



    forOwn(report.report, (val, key) => {
      if (val.length > 0) {
        skillGroups.push(
          <Row key={shortid.generate()}>
            <Col xs='12'>
              <SkillGroup
                report={val}
                title={val[0] ? val[0].name : ''}
                color={color}
                parentReport={key}
                activeParentReport={this.state.activeParentReport}
                setActiveParent={this.setActiveParent}
                nodeFilter={nodeFilter}
                navTo={navTo}
                query={query}
                skillReportLink = {skillReportLink}
                isCompare = {this.props.isCompare}
                isSwap = {this.props.isSwap}
              />
            </Col>
          </Row>
        )
      }
    })

    // links to other report views
    const q = Object.assign({}, query)
    delete q.item
    const reportQueryString = queryString.stringify(q)
    let dashQuery = ''
    if (!isStudent) {
      dashQuery = `?gua=${userAssessmentId}`
      if (scaleScore) {
        scaleScore = Math.round(scaleScore * 10 ) / 10
      }
    } else {
      if (scaleScore) {
        scaleScore = Math.round(scaleScore)
      }
    }

    if (!isStudent) {
      dashQuery = `?gua=${userAssessmentId}`
      if (scaleScore) {
        scaleScore = Math.round(scaleScore * 10 ) / 10
      }
    } else {
      if (scaleScoreCompare) {
        scaleScoreCompare = Math.round(scaleScoreCompare)
      }
    }
    return (
      <div>
          <AssessDashCircle
            top={false}
            subject={name}
            score={scaleScore}
            compareScore = {scaleScoreCompare}
            isCompare = {this.props.isCompare}
            test1 = {this.props.test1}
            test2 = {this.props.test2}
            isSwap = {this.props.isSwap}

          />
          {/* <Row>
            <Col>
              <Link to={overviewLink}>
                <Button block>View Overview</Button>
              </Link>
            </Col>
            <Col>
              <Link to={skillReportLink}>
                <Button block>View Report</Button>
              </Link>
            </Col>
          </Row> */}
          <div>
          {skillGroups}
          </div>
        </div>
    )
  }
}

export default SkillGroups


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessOverviewFilter/SkillGroups.js